import { render, staticRenderFns } from "./PagoComprobantes.vue?vue&type=template&id=225a2313&"
import script from "./PagoComprobantes.vue?vue&type=script&lang=js&"
export * from "./PagoComprobantes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports